// MIT License - Copyright (c) 2026 Doug McNall

import React, { useState } from 'react';
import UniversalModal from './UniversalModal';
import CrewRosterModal from './CrewRosterModal';
import CrewRelationshipModal from './CrewRelationshipModal';
import RecreationPanel from './RecreationPanel';
import CrewTrainingOverview from './CrewTrainingOverview';
import { useCredits } from '../contexts/CreditsContext';
import { useAlerts } from '../contexts/AlertContext';

/**
 * Crew Management Screen
 * Consolidates: Roster, Hire, Relationships, Training
 */
const CrewManagementScreen = ({ onClose, embedded = false }) => {
  const [activeTab, setActiveTab] = useState('roster');
  useCredits();
  useAlerts();

  const tabs = [
    { id: 'roster', label: 'Roster', icon: '👥' },
    { id: 'relationships', label: 'Relations', icon: '💬' },
    { id: 'recreation', label: 'Recreation', icon: '🎮' },
    { id: 'training', label: 'Training', icon: '📚' }
  ];

  const content = (
    <>
      {activeTab === 'roster' && (
        <div className="tab-content">
          <CrewRosterModal onClose={() => {}} embedded />
        </div>
      )}
      
      {activeTab === 'relationships' && (
        <div className="tab-content">
          <CrewRelationshipModal onClose={() => {}} embedded />
        </div>
      )}

      {activeTab === 'recreation' && (
        <div className="tab-content">
          <RecreationPanel embedded />
        </div>
      )}
      
      {activeTab === 'training' && (
        <div className="tab-content">
          <CrewTrainingOverview embedded />
        </div>
      )}
    </>
  );

  if (embedded) {
    return (
      <div className="crew-management-embedded">
        <div className="embedded-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`embedded-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span>{tab.icon}</span> {tab.label}
            </button>
          ))}
        </div>
        {content}
      </div>
    );
  }

  return (
    <UniversalModal
      title="CREW MANAGEMENT"
      subtitle="Roster, Hiring, Relationships & Training"
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      onClose={onClose}
      className="crew-management-screen"
    >
      {content}
    </UniversalModal>
  );
};

export default CrewManagementScreen;
